import { render, staticRenderFns } from "./TagFilters.vue?vue&type=template&id=249171c2&"
import script from "./TagFilters.vue?vue&type=script&lang=js&"
export * from "./TagFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports